const config = {
    // basename: only at build time to set, and don't add '/' at end off BASENAME for breadcrumbs, also don't put only '/' use blank('') instead,
    // like '/berry-material-react/react/default'
    basename: '',
    defaultPath: '/dashboard/invoice',
    fontFamily: `'Roboto', sans-serif`,
    borderRadius: 12,
    // API_SERVER: 'http://timesheet.galaxycine.vn:8888/api/'
    API_SERVER: 'https://hoadondieuchinh.galaxystudio.vn/api/'
};

export default config;
